import type { FC } from "react"

import { ConfirmationDialog } from "@/components/common/Modals"

interface EntityLockConflictDialogProps {
  message: string
  onClose: () => void
  onRefresh: () => void
  entityLabel?: string
}

export const EntityLockConflictDialog: FC<EntityLockConflictDialogProps> = ({
  message,
  onClose,
  onRefresh,
  entityLabel = "invoice",
}) => (
  <ConfirmationDialog
    title={`This ${entityLabel} was updated by another user`}
    content={message}
    closeLabel='Go Back'
    confirmLabel='Refresh'
    isWarning
    testIdPrefix='entity-lock.conflict-dialog'
    closeButtonTestIdSuffix='go-back-button'
    confirmButtonTestIdSuffix='refresh-button'
    onClose={onClose}
    onConfirm={onRefresh}
  />
)
